export default __webpack_public_path__ + "static/media/rabbitmq.abb59977.svg";